import React from 'react';
import styled from 'styled-components';
import THEME from '../../theme';
import PlaceholderLoader from '../PlaceholderLoader';
import Category from './Category';
import Result from './Result';
const Results = (props) => {
    const { results, open, activeElm } = props;
    const loading = results === 'loading';
    const categories = results !== 'loading'
        ? Array.from(new Set(results.map((r) => (r.category != null ? r.category : null))))
        : [];
    const categoryResults = results !== 'loading'
        ? categories.map((category) => results.filter((res) => res.category === category))
        : [];
    const hasCategories = categories.length > 1;
    const categorySizes = categoryResults
        .map((results) => results.length)
        .reduce((acc, len, i) => acc.concat([len + (acc[i - 1] || 0)]), []);
    return (React.createElement(Wrapper, { style: props.resultsStyle, className: "search-results" }, open && (React.createElement("div", null,
        loading && (React.createElement(ResultStyled, null,
            React.createElement("h3", null,
                React.createElement(PlaceholderLoader, { width: "60%", height: "20px", inline: true }),
                React.createElement("span", null,
                    React.createElement(PlaceholderLoader, { width: "50px", height: "15px" }))),
            React.createElement("div", null,
                React.createElement(PlaceholderLoader, { width: "40%", height: "15px" })))),
        !loading && Array.isArray(results) && (React.createElement(React.Fragment, null, hasCategories
            ? categories.map((c, ci) => (React.createElement(Category, { label: c, key: c || Math.random() }, results
                .filter((r) => r.category == c)
                .map((result, i) => {
                const index = (categorySizes[ci - 1] || 0) + i;
                return (React.createElement(Result, { key: result.key, result: result, active: index === activeElm, index: i, onMouseDown: props.resultOnMouseDown }));
            }))))
            : results.map((result, i) => (React.createElement(Result, { key: result.key || Math.random(), result: result, active: i === activeElm, index: i, onMouseDown: props.resultOnMouseDown })))))))));
};
export default Results;
const Wrapper = styled.div `
  position: absolute;
  width: 100%;
  background: ${THEME.COLOR_SECONDARY};
  max-height: 300px; /* calc(100vh - 46px); */
  overflow-y: auto;
  z-index: 999999;
  top: calc(100% - 20px);
`;
const ResultStyled = styled.div `
  position: relative;
  padding: 10px;
  display: block;
  border-bottom: 1px solid lightgrey;
  text-decoration: none;
  cursor: pointer;
  border-right: 1px solid lightgrey;
  border-left: 1px solid lightgrey;
  overflow: hidden;

  &.active,
  &:hover {
    background: lightgrey;
  }

  .supplementary {
    padding-top: 5px;
    font-size: 0.8em;

    small {
      float: right;
    }
  }

  h3 {
    font-size: 0.85em;
    margin: 0;
    & > span {
      float: right;
      font-size: 0.9em;
    }
    .label {
      font-size: 0.5em;
      border-radius: 2px;
      background-color: lightgrey;
      color: ${THEME.COLOR_SECONDARY};
      display: inline-block;
      padding: 0.2em 0.4em;
      vertical-align: middle;
    }
  }
  p {
    margin: 2px 0;
    color: grey;
    font-size: 0.7em;
  }

  .t-fr {
    float: right;
  }

  .progressbar {
    border-radius: 1px;
    overflow: hidden;
    border: 1px solid ${THEME.COLOR_PRIMARY};
    opacity: 0.5;

    .progress {
      height: 2px;
      background-color: ${THEME.COLOR_PRIMARY};
    }
  }
`;
//# sourceMappingURL=Results.js.map